import {isUndefined} from 'lodash';

import {ConversationModel} from '../../models/api/conversationModel';
import {ApiConversationSplit} from '../../models/api/conversationSplitModel';
import {mergeDataGroups} from '../../models/api/dataGroupModel';
import {MessageModel} from '../../models/api/messageModel';
import {ThunkAsyncAction} from '../../store/appThunk';
import {updateDataAction} from '../../store/data/dataGroupsActions';
import {getConversations} from '../../store/data/dataSelectors';
import {postApiAsync} from '../http/http';

export function splitConversationTask(
  conversationId: number,
  message: MessageModel,
): ThunkAsyncAction<ConversationModel | undefined> {
  return async (dispatch, getState) => {
    const url = `${message.url}/split`;
    const serverDataGroups = await postApiAsync(ApiConversationSplit, url, {});

    // Update the store.
    const {originalDataGroup, destinationDataGroup} = serverDataGroups;
    const dataGroup = mergeDataGroups(originalDataGroup, destinationDataGroup);
    dispatch(updateDataAction(dataGroup));

    // Find the destination conversation after the merge.
    const destinationConversationId = destinationDataGroup.conversations?.[0]?.id;
    return !isUndefined(destinationConversationId)
      ? getConversations(getState())[destinationConversationId]
      : undefined;
  };
}
